import QueryContext from '@/api/QueryContext';
import api from '../index';

const INVITED_MATCHES_INCLUDE = [
  'active_contract',
  'profile',
  'profile.identities',
];

const campaignCreatorMatchesFetchers = {
  invited: (context: QueryContext) =>
    api.get(`/campaigns/${context.meta?.campaignId}/campaign_creator_matches`, {
      params: {
        filter: 'invited',
        include: INVITED_MATCHES_INCLUDE,
        page: context.meta?.page,
        per_page: context.meta?.perPage,
        sort: context.meta?.sort,
      },
    }),
};

export default campaignCreatorMatchesFetchers;
